import moment, { Moment } from "moment";

import { Prize, PrizeDTO } from "../Prize";

export interface PrizeOrderDTO {
  id: number;
  orderDate: string;
  application: string;
  applicationOrderId: number;
  budgetValue: string; // "0.00"
  vatRate: number;
  supplierItem?: PrizeDTO;
  itemName: {
    pl: string;
  };
  itemDescription: {
    pl: string;
  };
  deliveryAddress: string;
  deliveryEmail: string;
  deliveryPhone: string;
  quantity: number;
}

export class PrizeOrder {
  private _id: number = 0;
  private _orderDate: Moment = moment();
  private _application: string = "";
  private _applicationOrderId: number = 0;
  private _budgetValue: number = 0;
  private _vatRate: number = 0;
  private _supplierItem: Prize = new Prize();
  private _itemName: string = "";
  private _itemDescription: string = "";
  private _deliveryAddress: string = "";
  private _deliveryEmail: string = "";
  private _deliveryPhone: string = "";
  private _quantity: number = 0;

  static create(order: PrizeOrderDTO): PrizeOrder {
    const instance = new PrizeOrder();

    instance._id = order.id;
    instance._orderDate = moment(order.orderDate);
    instance._application = order.application;
    instance._applicationOrderId = order.applicationOrderId;
    instance._budgetValue = Number(order.budgetValue);
    instance._vatRate = order.vatRate;

    if (order.supplierItem) {
      instance._supplierItem = Prize.create(order.supplierItem);
    }

    instance._itemName = order.itemName.pl;
    instance._itemDescription = order.itemDescription.pl;
    instance._deliveryAddress = order.deliveryAddress;
    instance._deliveryEmail = order.deliveryEmail;
    instance._deliveryPhone = order.deliveryPhone;
    instance._quantity = order.quantity;

    return instance;
  }

  public get id() {
    return this._id;
  }

  public get orderDate() {
    return this._orderDate.format("DD.MM.YYYY");
  }

  public get application() {
    return this._application;
  }

  public get applicationOrderId() {
    return this._applicationOrderId;
  }

  public get budgetValue() {
    return this._budgetValue;
  }

  public get vatRate() {
    return this._vatRate;
  }

  public get supplierItem() {
    return this._supplierItem;
  }

  public get itemName() {
    return this._itemName;
  }

  public get itemDescription() {
    return this._itemDescription;
  }

  public get deliveryAddress() {
    return this._deliveryAddress;
  }

  public get deliveryEmail() {
    return this._deliveryEmail;
  }

  public get deliveryPhone() {
    return this._deliveryPhone;
  }

  public get quantity() {
    return this._quantity;
  }
}
